import React from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import HelpPanelButton from '@atlassian/jira-help-panel-button';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import {
	WHAT_ARE_COMPASS_COMPONENTS_ARTICLE_ID,
	WHAT_ARE_COMPASS_COMPONENTS_SUPPORT_URL,
	WHAT_ARE_JIRA_COMPONENTS_ARTICLE_ID,
	WHAT_ARE_JIRA_COMPONENTS_SUPPORT_URL,
} from '../../constants';
import messages from './messages';

type Props = {
	isGlobalComponentsEnabled: boolean;
	searchBar: React.ReactNode;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	formatMessage: (messageDescriptor: any, values?: Record<string, any>) => string;
};

export const HeaderBottombarContent = (props: Props) => {
	const { isGlobalComponentsEnabled, searchBar, formatMessage } = props;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const learnMoreOnClick = (_: any, analyticEvent: UIAnalyticsEvent) => {
		fireUIAnalytics(
			analyticEvent,
			isGlobalComponentsEnabled
				? 'learnMoreAboutCompassComponentsLink'
				: 'learnMoreAboutJiraComponentsLink',
		);
	};

	return (
		<>
			<Box
				testId={
					isGlobalComponentsEnabled
						? 'project-directories.components.content.compass-header-content'
						: 'project-directories.components.content.jira-header-content'
				}
				xcss={compassHeaderTextStyles}
				paddingBlockEnd="space.300"
			>
				{formatMessage(isGlobalComponentsEnabled ? messages.headerCompass : messages.headerJira, {
					link: (text: React.ReactNode) => (
						<HelpPanelButton
							articleId={
								isGlobalComponentsEnabled
									? WHAT_ARE_COMPASS_COMPONENTS_ARTICLE_ID
									: WHAT_ARE_JIRA_COMPONENTS_ARTICLE_ID
							}
							appearance="link"
							onClick={learnMoreOnClick}
							spacing="none"
							fallbackComponent={
								<Button
									href={
										isGlobalComponentsEnabled
											? WHAT_ARE_COMPASS_COMPONENTS_SUPPORT_URL
											: WHAT_ARE_JIRA_COMPONENTS_SUPPORT_URL
									}
									target="_blank"
									onClick={learnMoreOnClick}
									appearance="link"
									spacing="none"
								>
									{text}
								</Button>
							}
						>
							{text}
						</HelpPanelButton>
					),
				})}
			</Box>
			{!isGlobalComponentsEnabled && searchBar}
		</>
	);
};

const compassHeaderTextStyles = xcss({
	width: '611px',
});
